import React from "react";
import { Mountain, Landmark, Compass } from "lucide-react";
const AdditionalLocations: React.FC = () => {
  return <div className="mt-16 bg-joerg-50 p-8 rounded-2xl shadow-soft animate-fade-in my-[65px]">
      <h3 className="text-xl font-semibold mb-3 text-center">Weitere inspirierende Orte für dein Coaching</h3>
      <p className="text-joerg-600 mb-8 mx-0 my-0 px-0">
        Neben dem Rothsee und den Alpen biete ich auch Coaching-Erlebnisse an anderen besonderen Orten an. 
        Die Umgebung wird dabei individuell auf deine Bedürfnisse und Themen abgestimmt.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        <div className="flex flex-col items-center">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-4">
            <Mountain className="h-5 w-5" />
          </div>
          <div className="text-center">
            <h4 className="font-medium mb-2">Fränkische Schweiz</h4>
            <p className="text-sm text-joerg-600 text-left">
              Malerische Landschaft mit Felsen, Höhlen und Wäldern – ideal für tiefgreifende Perspektivwechsel
            </p>
          </div>
        </div>
        
        <div className="flex flex-col items-center">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-4">
            <Landmark className="h-5 w-5" />
          </div>
          <div className="text-center">
            <h4 className="font-medium mb-2">Stadtparks & Kulturorte</h4>
            <p className="text-sm text-joerg-600 text-left">
              Inspirierende urbane Umgebungen wie Museen, botanische Gärten oder historische Plätze
            </p>
          </div>
        </div>
        
        <div className="flex flex-col items-center">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-4">
            <Compass className="h-5 w-5" />
          </div>
          <div className="text-center">
            <h4 className="font-medium mb-2">Dein Wunschort</h4>
            <p className="text-sm text-joerg-600 text-left">
              Hast du einen persönlichen Kraftort? Gerne gestalten wir dein Coaching an einem Ort deiner Wahl
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default AdditionalLocations;